import React from "react";

const CustomTextarea = ({
  placeholder = "",
  value,
  onChange,
  label, // Prop para el label opcional
  rows = 4, // Número de filas predeterminado para el textarea
  ...props
}) => {
  return (
    <div className="poppins-medium flex flex-col space-y-1 tracking-wider">
      {/* Renderiza el label solo si se pasa como prop */}
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">{label}</label>
      )}

      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={rows}
        className={`w-full px-4 py-3 rounded-[9px] bg-[#F9FAFB] text-[10px] poppins-regular placeholder-[#C9C9C9] focus:outline-none focus:ring-2 focus:ring-blue-500 tracking-wider resize-none`}
        {...props}
      />
    </div>
  );
};

export default CustomTextarea;
